import { motion, useTransform, useScroll } from "framer-motion";
import React, { useRef } from "react";
import {HiArrowRight} from "react-icons/hi2";
import {BsArrow90DegRight} from "react-icons/bs";

const HorizontalScrollCarousel = () => {
    const targetRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: targetRef,
    });

    const x = useTransform(scrollYProgress, [0, 1], ["1.5%", "-91%"]);

    return (
        <section ref={targetRef} className="relative h-[300vh] ">
            <div className="sticky top-0 flex h-screen items-center overflow-hidden">
                <motion.div style={{ x }} className="flex gap-4">
                    {cards.map((card) => {
                        return <Card card={card} key={card.id} />;
                    })}
                </motion.div>
            </div>
        </section>
    );
};

const Card = ({ card }) => {
    return (
        <div
            key={card.id}
            className="group relative h-screen sm:w-[90rem] w-[45rem] overflow-hidden flex items-center"
        >
            <div className="flex">
                <div className="max-w-[75rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
                    <div className="md:grid md:grid-cols-2 md:gap-10 lg:gap-16 items-center">
                        <div className="hidden md:block mb-24 md:mb-0 sm:px-6">
                            <div className="relative">
                                <img className="rounded-xl opacity-60" src="https://dummyimage.com/450x500" alt="Description"/>
                                <div className="absolute bottom-0 start-0 -z-[1] translate-y-10 -translate-x-14">
                                    <svg className="max-w-40 h-auto text-slate-400" width="696" height="653" viewBox="0 0 696 653" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="72.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="171.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="270.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="369.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="468.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="567.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="666.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="29.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="128.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="227.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="326.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="425.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="524.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="623.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="72.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="171.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="270.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="369.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="468.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="567.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="666.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="29.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="128.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="227.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="326.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="425.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="524.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="623.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="72.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="171.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="270.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="369.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="468.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="567.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="666.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="29.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="128.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="227.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="326.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="425.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="524.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="623.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="72.5" cy="623.5" r="29.5" fill="currentColor"/>
                                        <circle cx="171.5" cy="623.5" r="29.5" fill="currentColor"/>
                                        <circle cx="270.5" cy="623.5" r="29.5" fill="currentColor"/>
                                        <circle cx="369.5" cy="623.5" r="29.5" fill="currentColor"/>
                                        <circle cx="468.5" cy="623.5" r="29.5" fill="currentColor"/>
                                        <circle cx="567.5" cy="623.5" r="29.5" fill="currentColor"/>
                                        <circle cx="666.5" cy="623.5" r="29.5" fill="currentColor"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div>
                            <blockquote className="relative">
                                <svg className="absolute top-0 start-0 transform -translate-x-8 -translate-y-4 size-24 text-gray-200" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M7.39762 10.3C7.39762 11.0733 7.14888 11.7 6.6514 12.18C6.15392 12.6333 5.52552 12.86 4.76621 12.86C3.84979 12.86 3.09047 12.5533 2.48825 11.94C1.91222 11.3266 1.62421 10.4467 1.62421 9.29999C1.62421 8.07332 1.96459 6.87332 2.64535 5.69999C3.35231 4.49999 4.33418 3.55332 5.59098 2.85999L6.4943 4.25999C5.81354 4.73999 5.26369 5.27332 4.84476 5.85999C4.45201 6.44666 4.19017 7.12666 4.05926 7.89999C4.29491 7.79332 4.56983 7.73999 4.88403 7.73999C5.61716 7.73999 6.21938 7.97999 6.69067 8.45999C7.16197 8.93999 7.39762 9.55333 7.39762 10.3ZM14.6242 10.3C14.6242 11.0733 14.3755 11.7 13.878 12.18C13.3805 12.6333 12.7521 12.86 11.9928 12.86C11.0764 12.86 10.3171 12.5533 9.71484 11.94C9.13881 11.3266 8.85079 10.4467 8.85079 9.29999C8.85079 8.07332 9.19117 6.87332 9.87194 5.69999C10.5789 4.49999 11.5608 3.55332 12.8176 2.85999L13.7209 4.25999C13.0401 4.73999 12.4903 5.27332 12.0713 5.85999C11.6786 6.44666 11.4168 7.12666 11.2858 7.89999C11.5215 7.79332 11.7964 7.73999 12.1106 7.73999C12.8437 7.73999 13.446 7.97999 13.9173 8.45999C14.3886 8.93999 14.6242 9.55333 14.6242 10.3Z" fill="currentColor"/>
                                </svg>
                                <div className="relative z-10">
                                    <p className="text-xs font-semibold text-gray-500 tracking-wide uppercase mb-3 ">
                                        {card.num}
                                    </p>
                                    <motion.div
                                        className="text-xl font-medium italic text-orange-500 md:text-2xl md:leading-normal xl:text-3xl xl:leading-normal sm:w-auto w-screen px-4"
                                        variants={{
                                            hidden: { opacity: 0, x: -50 },
                                            visible: { opacity: 1, x: 0 }
                                        }}
                                        initial="hidden"
                                        whileInView="visible"
                                        transition={{duration: 0.6, delay: 0.4}}
                                        viewport={{once: false}}
                                    >
                                        {card.content}
                                    </motion.div>
                                </div>
                                <footer className="mt-6">
                                    <div className="flex items-center">
                                        <div className="md:hidden flex-shrink-0">
                                            <img className="size-12 rounded-full" src="https://dummyimage.com/100x100" alt="Description"/>
                                        </div>
                                        <div className="ms-4 md:ms-0">
                                            <div className="text-base font-semibold text-gray-800 ">
                                                {card.name}
                                            </div>
                                            <div className="text-xs text-gray-500 ">
                                                {card.org}
                                            </div>
                                        </div>
                                    </div>
                                </footer>
                                <div className="mt-8 lg:mt-14">
                                    <div className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-gray-800 text-white hover:bg-gray-900 disabled:opacity-50 disabled:pointer-events-none " href="#">
                                        Read the story
                                    </div>
                                </div>
                            </blockquote>
                        </div>
                    </div>
                </div>
                { card.id!==7 ?
                    <motion.div
                        className="text-6xl my-auto ml-24"
                        variants={{
                            hidden: { opacity: 0, x: -50 },
                            visible: { opacity: 1, x: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.8}}
                        viewport={{once: false}}
                    >
                        <HiArrowRight />
                    </motion.div> :
                    <motion.div
                        className="my-auto text-6xl ml-24"
                        variants={{
                            hidden: { opacity: 0, y: -50 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.8}}
                        viewport={{once: false}}
                    >
                        <BsArrow90DegRight className="rotate-90" />
                    </motion.div> }
            </div>
        </div>
    );
};

const cards = [
    {
        num: "Quote No.1",
        content: "This is the content of quote No.1 This is the content of quote No.1 This is the content of quote No.1 This is the content of quote No.1 ",
        name: "First-name-1 Last-name-1",
        org: "Organization No.1",
        id: 1,
    },
    {
        num: "Quote No.2",
        content: "This is the content of quote No.2 This is the content of quote No.2 This is the content of quote No.2 This is the content of quote No.2 ",
        name: "First-name-2 Last-name-2",
        org: "Organization No.2",
        id: 2,
    },
    {
        num: "Quote No.3",
        content: "This is the content of quote No.3 This is the content of quote No.3 This is the content of quote No.3 This is the content of quote No.3 ",
        name: "First-name-3 Last-name-3",
        org: "Organization No.3",
        id: 3,
    },
    {
        num: "Quote No.4",
        content: "This is the content of quote No.4 This is the content of quote No.4 This is the content of quote No.4 This is the content of quote No.4 ",
        name: "First-name-4 Last-name-4",
        org: "Organization No.4",
        id: 4,
    },
    {
        num: "Quote No.5",
        content: "This is the content of quote No.5 This is the content of quote No.5 This is the content of quote No.5 This is the content of quote No.5 ",
        name: "First-name-5 Last-name-5",
        org: "Organization No.5",
        id: 5,
    },
    {
        num: "Quote No.6",
        content: "This is the content of quote No.6 This is the content of quote No.6 This is the content of quote No.6 This is the content of quote No.6 ",
        name: "First-name-6 Last-name-6",
        org: "Organization No.6",
        id: 6,
    },
    {
        num: "Quote No.7",
        content: "This is the content of quote No.7 This is the content of quote No.7 This is the content of quote No.7 This is the content of quote No.7 ",
        name: "First-name-7 Last-name-7",
        org: "Organization No.7",
        id: 7,
    }
];

export default function HorizontalScrollQuote(){
    return(
        <HorizontalScrollCarousel />
    )
}